import { render, staticRenderFns } from "./waiting.vue?vue&type=template&id=6db01d18&scoped=true&"
import script from "./waiting.ts?vue&type=script&lang=ts&"
export * from "./waiting.ts?vue&type=script&lang=ts&"
import style0 from "./waiting.vue?vue&type=style&index=0&id=6db01d18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db01d18",
  null
  
)

export default component.exports